export const APP_BRAND_NAME = "Docpose";
export const APP_LOGO_URL = "/app-logo.webp";
export const APP_FAVICON_URL = "/favicon-32x32.png";
export const APP_SVG_LOGO_URL = "/placeholder.svg";
export const APP_LOGO_FILENAME = "app-logo.png";
export const APP_FAVICON_FILENAME = "favicon.png";
